import React from 'react';
import ActionButton from 'jbc-front/components/ActionButton';
import { Revert, Delete } from 'jbc-front/components/icons';
import ChangePolicyModal from './ChangePolicyModal';
import DeletePolicyModal from './DeletePolicyModal';
import styles from './EditPolicy.scss';
import { withTranslation } from 'react-i18next';

export default withTranslation()(class EditPolicy extends React.Component {
  state = {
    isChangeModalOpen: false,
    isDeleteModalOpen: false
  };

  render() {
    return (
      <div className={styles.wrap}>
        <ActionButton
          onClick={() => this.setState({ ...this.state, isChangeModalOpen: true })}
          icon={<Revert size={16} />}
        >
          {this.props.t('features.RoleUsers.containers.EditPolicy.change_the_authority_of_checked_accounts_in_bulk')}
        </ActionButton>
        <ChangePolicyModal
          isOpen={this.state.isChangeModalOpen}
          hideModal={() => {
            this.setState({ ...this.state, isChangeModalOpen: false });
          }}
        />
        <ActionButton
          onClick={() => this.setState({ ...this.state, isDeleteModalOpen: true })}
          icon={<Delete size={16} />}
        >
          {this.props.t('features.RoleUsers.containers.EditPolicy.delete_the_checked_accounts')}
        </ActionButton>
        <DeletePolicyModal
          isOpen={this.state.isDeleteModalOpen}
          hideModal={() => {
            this.setState({ ...this.state, isDeleteModalOpen: false });
          }}
        />
      </div>
    );
  }
})
